module.exports = __webpack_public_path__ + "img/世联估价@2x.d92ee35a.png";